import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

export interface HoldAppointmentRequest {
  locatorId: number;
  serviceType: number;
  apptDateTime: string;
}

export interface HoldAppointmentResponse {
  confirmationCode: string;
  expiresAt: number;
}

export interface HoldAppointmentError {
  status: 'error';
  errors: Array<{
    field: string;
    message: string;
  }>;
}

@Injectable({
  providedIn: 'root',
})
export class HoldAppointmentService {
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  holdAppointment(
    request: HoldAppointmentRequest
  ): Observable<HoldAppointmentResponse> {
    const baseUrl = this.environmentService.appointmentSchedulingBaseUrl;

    const apiUrl = `${baseUrl}hold`;

    return this.http
      .post<HoldAppointmentResponse>(apiUrl, request, {
        headers: { 'x-client-type': 'patient' },
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  freeAppointment(confirmationCode: string): Observable<void> {
    const baseUrl = this.environmentService.appointmentSchedulingBaseUrl;

    const apiUrl = `${baseUrl}${encodeURIComponent(confirmationCode)}/free`;

    // Ignore errors when freeing - backend has cleanup job
    return this.http
      .put<void>(
        apiUrl,
        {},
        {
          headers: { 'x-client-type': 'patient' },
        }
      )
      .pipe(
        map(() => undefined),
        catchError(() => throwError(new Error('Failed to free appointment')))
      );
  }
}
